import { render, staticRenderFns } from "./BaseColorpicker.vue?vue&type=template&id=4c2d718a&scoped=true&"
import script from "./BaseColorpicker.vue?vue&type=script&lang=ts&"
export * from "./BaseColorpicker.vue?vue&type=script&lang=ts&"
import style0 from "./BaseColorpicker.vue?vue&type=style&index=0&id=4c2d718a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2d718a",
  null
  
)

export default component.exports